// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cStxD","content":"styles_content__CDULF","description":"styles_description__nOiL7"};